import { defineMessages } from 'react-intl';

export const complimentaryTrialEndBannerMessages = defineMessages({
  activeBody: {
    defaultMessage:
      '<emphasis>Your complimentary Max usage ends {date}.</emphasis> <limits>Limits apply</limits> after.',
    id: '4NIkCGYZwo',
    description:
      'Top strip banner in the last week of complimentary Heidi II Max usage for members who use Heidi agents a lot; links to the usage limits help article',
  },
  inactiveBody: {
    defaultMessage:
      '<emphasis>Your complimentary Max usage to try Heidi Agents ends {date}.</emphasis> <limits>Limits apply</limits> after.',
    id: 'nm30xCFfT9',
    description:
      'Top strip banner in the last week of complimentary Heidi II Max usage for members who have barely used Heidi agents; links to the usage limits help article',
  },
  keepUsage: {
    defaultMessage: 'Keep usage',
    id: '4yxWw1wx1O',
    description:
      'Button on the complimentary usage end banner that opens the upgrade modal to keep Max usage',
  },
  giveTask: {
    defaultMessage: 'Give Heidi a task',
    id: 'JEZgcj78WB',
    description:
      'Button on the complimentary usage end banner that opens the Tasks list on Home so the member can try Heidi agents',
  },
  dismissLabel: {
    defaultMessage: 'Dismiss complimentary usage banner',
    id: 'FWemi1rdI/',
    description: 'Accessible label for closing the complimentary usage end banner',
  },
});

export const complimentaryTrialEndModalMessages = defineMessages({
  title: {
    defaultMessage:
      'Your complimentary Max usage ends in {count, plural, one {# day} other {# days}}',
    id: 'LgYbcJjND2',
    description:
      'Title of the upgrade modal shown in the last week of complimentary Heidi II Max usage',
  },
  body: {
    defaultMessage:
      'From {date} <limits>usage limits</limits> will apply. To keep using agentic features, upgrade to Max.',
    id: 'HcyvAxc7RU',
    description:
      'Body of the complimentary usage end modal; date is when the complimentary usage ends, links to the usage limits help article',
  },
  getClinicianMax: {
    defaultMessage: 'Get Clinician Max',
    id: 'ksHttSLcBb',
    description:
      'Primary button in the complimentary usage end modal that starts Clinician Max checkout',
  },
  viewAllPlans: {
    defaultMessage: 'View all plans',
    id: 'IPJR/3+31h',
    description:
      'Secondary button in the complimentary usage end modal that opens the pricing plans modal',
  },
  footnote: {
    defaultMessage: 'After {date} you’ll automatically return to your plan usage limits.',
    id: '2kB1GzBsxQ',
    description:
      'Footnote in the complimentary usage end modal explaining what happens if the member does not upgrade',
  },
});

export const complimentaryTrialEndOfferMessages = defineMessages({
  title: {
    defaultMessage: 'Save an extra {percent}% with a yearly Max seat plan.',
    id: 'XvHbnZvyyH',
    description:
      'Offer card in the complimentary usage end modal and upgrade checkout: discount for choosing yearly billing on a Max seat',
  },
  caption: {
    defaultMessage:
      'Limited offer ends {date}. <conditions>Conditions apply.</conditions>',
    id: 'P26jAxn6Dy',
    description:
      'Caption under the yearly Max seat offer; date is when complimentary usage ends, links to the offer conditions',
  },
});
